import { useCallback, useContext, useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import Layout from "../../../Components/Layout/Layout";
import { ContextAPI } from "../../../common/Context/ContextApi";
import { ManageApis } from "../../../common/APIS/ManageApis";
import { FailedPopup } from "../../../common/Utils/Utils";
import DataTable from "../../../Components/DataTable/DataTable";
import { Skeleton } from "@arco-design/web-react";
import NoData from "../../../Components/NoData/NoData";
import PopupModal from "../../../Components/PopupModal";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";

const TAB_KEYS = {
  ACCOUNTS: "accounts",
  ELIGIBLE: "eligible",
};

const getListPayload = (response) => {
  const responseData = response?.response_data?.data ?? response?.response_data ?? {};
  const docs = Array.isArray(responseData?.docs)
    ? responseData.docs
    : Array.isArray(responseData?.data)
      ? responseData.data
      : Array.isArray(responseData)
        ? responseData
        : [];

  return {
    docs,
    total: Number(responseData?.total ?? responseData?.totalDocs ?? responseData?.count ?? docs.length ?? 0),
  };
};

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const formattedValue = `${value}`;
  return formattedValue.includes("₹") ? formattedValue : `₹${formattedValue}`;
};

const formatInterestRate = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const formattedValue = `${value}`;
  return formattedValue.includes("%") ? formattedValue : `${formattedValue}%`;
};

const formatChittyDetails = (record = {}) => {
  const chitNumber = `${
    record?.chit_id ?? record?.chitty_no ?? record?.chittyNo ?? record?.chit_no ?? record?.chit_reg_no ?? ""
  }`.trim();
  const chittalNumber = record?.chittal_no ?? record?.chittalNo;

  if (chitNumber && chittalNumber !== null && chittalNumber !== undefined && chittalNumber !== "") {
    return `${chitNumber}-${chittalNumber}`;
  }

  return chitNumber || (chittalNumber !== null && chittalNumber !== undefined && chittalNumber !== "" ? `${chittalNumber}` : "-");
};

const getPBODApplyChittyNo = (record = {}) => {
  const chitNumber = `${
    record?.chit_reg_no ?? record?.chit_id ?? record?.chitty_no ?? record?.chittyNo ?? record?.chit_no ?? ""
  }`.trim();

  if (!chitNumber) return "";

  if (record?.chit_reg_no) return chitNumber;

  const parts = chitNumber.split("/");
  return parts.length >= 2 ? `${parts[0]}/${parts[1]}` : chitNumber;
};

const getPBODBranchLabel = (record = {}) =>
  record?.branch_name ?? record?.branch?.name ?? record?.branch_id ?? "-";

const getPBODDeviceData = () => ({
  channel: "web",
  brand: "web",
  buildNumber: "1.0",
  bundleId: window?.location?.host || "web",
  deviceId: navigator.userAgent,
  ipAddress: "",
  deviceType: "Web Portal",
  modelNo: "",
  userAgent: navigator.userAgent,
});

const PassbookOdList = () => {
  const navigate = useNavigate();
  const { token } = useContext(ContextAPI);

  const [loading, setloading] = useState(false);
  const [activeTab, setActiveTab] = useState(TAB_KEYS.ACCOUNTS);

  const [list, setList] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);

  const [eligibleList, setEligibleList] = useState([]);
  const [eligibleCurrentPage, setEligibleCurrentPage] = useState(1);
  const [eligibleTotalPages, setEligibleTotalPages] = useState(0);
  const [selectedEligibleChit, setSelectedEligibleChit] = useState(null);
  const [applyConfirmVisible, setApplyConfirmVisible] = useState(false);
  const [agreementVisible, setAgreementVisible] = useState(false);
  const [agreementHtml, setAgreementHtml] = useState("");
  const [statusModal, setStatusModal] = useState({ open: false, title: "", message: "" });

  const myPassbookOdList = useCallback(async (page = 1) => {
    setloading(true);

    const reqstBody = {
      page: Number(page) || 1,
      size: 50,
      limit: 10,
    };

    let response = await ManageApis("post", global.getPBODaccounts, reqstBody, token);

    if (response?.message == "Success") {
      const { docs, total } = getListPayload(response);
      settotalPages(total);
      setList(response?.response_data?.status ? docs : []);
      setloading(false);
    } else {
      setList([]);
      settotalPages(0);
      setloading(false);
      FailedPopup(response);
    }
  }, [token]);

  const getEligiblePassbookOdList = useCallback(async (page = 1) => {
    setloading(true);

    const reqstBody = {
      page: Number(page) || 1,
      size: 50,
      limit: 10,
    };

    let response = await ManageApis(
      "post",
      global.getPassbookODEligibleList || "/chit/getPassbookODEligibleList",
      reqstBody,
      token
    );

    if (response?.message == "Success") {
      const { docs, total } = getListPayload(response);
      setEligibleTotalPages(total);
      setEligibleList(response?.response_data?.status ? docs : []);
      setloading(false);
    } else {
      setEligibleList([]);
      setEligibleTotalPages(0);
      setloading(false);
      FailedPopup(response);
    }
  }, [token]);

  useEffect(() => {
    setList([]);
    myPassbookOdList(1);

    return () => {
      setList([]);
      setEligibleList([]);
    };
  }, [myPassbookOdList]);

  const handleChangeTable = ({ current }) => {
    myPassbookOdList(current);
    setcurrentPage(current);
  };

  const handleEligibleTableChange = ({ current }) => {
    getEligiblePassbookOdList(current);
    setEligibleCurrentPage(current);
  };

  const closeEligibleApplyFlow = () => {
    setApplyConfirmVisible(false);
    setAgreementVisible(false);
    setAgreementHtml("");
    setSelectedEligibleChit(null);
  };

  const getEligibleApplyReqBody = (record = selectedEligibleChit) => ({
    branch_id: record?.branch_id ?? record?.branch?.id ?? "",
    chittal_no: record?.chittal_no ?? record?.chittalNo ?? "",
    chitty_no: getPBODApplyChittyNo(record),
    device_data: getPBODDeviceData(),
  });

  const handleOpenEligibleApply = (record) => {
    setSelectedEligibleChit(record);
    setApplyConfirmVisible(true);
    setAgreementVisible(false);
    setAgreementHtml("");
  };

  const handleShowEligibleAgreement = async () => {
    try {
      const reqstBody = getEligibleApplyReqBody();

      if (!reqstBody.branch_id || !reqstBody.chittal_no || !reqstBody.chitty_no) {
        FailedPopup("Required Passbook OD details are missing.");
        return;
      }

      setloading(true);
      const response = await ManageApis(
        "post",
        global.getPassbookODAgreement || "/chit/getPassbookODAgreement",
        reqstBody,
        token
      );

      if (response?.response_data?.status) {
        const responseData = response?.response_data?.data;
        const htmlContent =
          typeof responseData === "string"
            ? responseData
            : responseData?.htmlContent || responseData?.data || "";

        setAgreementHtml(htmlContent || "<p>Agreement is not available.</p>");
        setApplyConfirmVisible(false);
        setAgreementVisible(true);
      } else {
        FailedPopup(response);
      }
    } catch (error) {
      FailedPopup(error?.message || "Unable to fetch Passbook OD agreement");
    } finally {
      setloading(false);
    }
  };

  const handleSubmitEligibleApply = async () => {
    try {
      const reqstBody = getEligibleApplyReqBody();

      if (!reqstBody.branch_id || !reqstBody.chittal_no || !reqstBody.chitty_no) {
        FailedPopup("Required Passbook OD details are missing.");
        return;
      }

      setloading(true);
      const response = await ManageApis(
        "post",
        global.applyPassbookOD || "/chit/applyPassbookOD",
        reqstBody,
        token
      );

      if (response?.response_data?.status) {
        closeEligibleApplyFlow();
        setStatusModal({
          open: true,
          title: "Success",
          message: response?.response_data?.message || "Passbook OD request submitted successfully.",
        });
        getEligiblePassbookOdList(eligibleCurrentPage);
      } else {
        FailedPopup(response);
      }
    } catch (error) {
      FailedPopup(error?.message || "Unable to submit Passbook OD request");
    } finally {
      setloading(false);
    }
  };

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    closeEligibleApplyFlow();

    if (tabKey === TAB_KEYS.ACCOUNTS) {
      setcurrentPage(1);
      myPassbookOdList(1);
    }

    if (tabKey === TAB_KEYS.ELIGIBLE) {
      setEligibleCurrentPage(1);
      getEligiblePassbookOdList(1);
    }
  };

  const TableColumn = [
    { title: "Branch Name", dataIndex: "branch_name" },
    { title: "Date of Sanction", dataIndex: "date_of_sanction" },
    { title: "Sanctioned Amount", dataIndex: "sanction_amount" },
    { title: "Account No", dataIndex: "account_no" },
    {
      title: "Action",
      dataIndex: "action",
      render: (v, rec) =>
        loading && activeTab === TAB_KEYS.ACCOUNTS ? (
          <Skeleton text={{ rows: 1, width: 100 }} />
        ) : (
          <div className="d-flex justify-content-end">
            <button
              className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100 ws_nowrp"
              onClick={() => navigate(`/passbookoddetails`, { state: { accountId: rec.account_no } })}
            >
              View
            </button>
          </div>
        ),
    },
  ];

  const eligibleTableColumn = [
    {
      title: "Branch Name",
      dataIndex: "branch_name",
      render: (value, rec) => value || rec?.branchName || rec?.branch?.name || "-",
    },
    {
      title: "Chitty Details",
      dataIndex: "chitty_details",
      render: (value, rec) => <span>{formatChittyDetails(rec)}</span>,
    },
    {
      title: "Eligible Amount",
      dataIndex: "eligible_amount",
      render: (value, rec) =>
        formatCurrency(
          value ??
            rec?.eligibleAmount ??
            rec?.eligibility_amount ??
            rec?.eligibilityAmount ??
            rec?.sanction_amount
        ),
    },
    {
      title: "Interest Rate",
      dataIndex: "interest_rate",
      render: (value, rec) => formatInterestRate(value ?? rec?.interestRate),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (value, rec) =>
        loading && activeTab === TAB_KEYS.ELIGIBLE ? (
          <Skeleton text={{ rows: 1, width: 100 }} />
        ) : (
          <div className="d-flex justify-content-end">
            <button
              className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100 ws_nowrp"
              onClick={() => handleOpenEligibleApply(rec)}
            >
              Apply
            </button>
          </div>
        ),
    },
  ];

  return (
    <Layout loading={loading}>
      <div className="pt-3 pb-4 px-3 px-md-4 overflow-auto custom_scroll1">
        <div className="mb-3">
          <div className="align-items-center d-flex justify-content-between flex-wrap">
            <BackBtn title={"My Smart PBL"} />
          </div>
        </div>
        <div>
          <div className="p-3 bg-white br_10 shadow_sm">
            {statusModal.open && (
              <PopupModal
                visible={statusModal.open}
                handleClose={() => setStatusModal({ open: false, title: "", message: "" })}
                title={statusModal.title}
                message={statusModal.message}
                buttons={[
                  {
                    text: "OK",
                    variant: "master",
                    onPress: () => setStatusModal({ open: false, title: "", message: "" }),
                  },
                ]}
              />
            )}

            {applyConfirmVisible && selectedEligibleChit && (
              <PopupModal
                visible={applyConfirmVisible}
                handleClose={closeEligibleApplyFlow}
                title={"Apply Passbook OD"}
                buttons={[
                  { text: "Cancel", variant: "master-line", onPress: closeEligibleApplyFlow },
                  { text: "Apply", variant: "master", onPress: handleShowEligibleAgreement },
                ]}
              >
                <div className="px-1">
                  {[
                    { label: "Branch", value: getPBODBranchLabel(selectedEligibleChit) },
                    { label: "Chitty", value: getPBODApplyChittyNo(selectedEligibleChit) || "-" },
                    { label: "Chittal", value: selectedEligibleChit?.chittal_no ?? selectedEligibleChit?.chittalNo ?? "-" },
                    {
                      label: "Eligible Amount",
                      value: formatCurrency(selectedEligibleChit?.eligible_amount),
                    },
                    {
                      label: "Interest Rate",
                      value: formatInterestRate(selectedEligibleChit?.interest_rate),
                    },
                  ].map((item) => (
                    <div className="d-flex align-items-center mb-2" key={item.label}>
                      <span className="font_13 fw_600" style={{ minWidth: "110px" }}>{item.label}</span>
                      <span className="px-2">:</span>
                      <span className="font_13">{item.value}</span>
                    </div>
                  ))}
                </div>
              </PopupModal>
            )}

            {agreementVisible && (
              <PopupModal
                visible={agreementVisible}
                handleClose={closeEligibleApplyFlow}
                title={"Passbook OD Agreement"}
                size="xl"
                scrollable={true}
                buttons={[
                  {
                    text: "Cancel",
                    variant: "master-line",
                    onPress: () => {
                      setAgreementVisible(false);
                      setApplyConfirmVisible(true);
                    },
                  },
                  { text: "Agree", variant: "master", onPress: handleSubmitEligibleApply },
                ]}
              >
                <div className="poxyModal">
                  <div className="height_t1 overflow-auto custom_scroll1 proxydoc">
                    {agreementHtml ? parse(agreementHtml) : <p>Agreement is not available.</p>}
                  </div>
                </div>
              </PopupModal>
            )}

            <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
              <div className="mb-2 mb-sm-3 d-flex justify-content-between align-items-center">
                <Nav className="gap-2 gap-sm-3 nav-tabs nav_tab_t3">
                  <Nav.Item className="flex-fill flex-sm-grow-0">
                    <Nav.Link eventKey={TAB_KEYS.ACCOUNTS}>My Smart PBL</Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="flex-fill flex-sm-grow-0">
                    <Nav.Link eventKey={TAB_KEYS.ELIGIBLE}>Eligible Chitties</Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>

              <Tab.Content>
                <Tab.Pane eventKey={TAB_KEYS.ACCOUNTS}>
                  {list?.length ? (
                    <div className="arco_table1 table-responsive custom_scroll1">
                      <DataTable
                        columnData={TableColumn}
                        rowData={list}
                        onChangeTable={handleChangeTable}
                        total={totalPages}
                        current={currentPage}
                        loading={loading && activeTab === TAB_KEYS.ACCOUNTS}
                      />
                    </div>
                  ) : (
                    <NoData title={"No Passbook OD found"} />
                  )}
                </Tab.Pane>

                <Tab.Pane eventKey={TAB_KEYS.ELIGIBLE}>
                  {eligibleList?.length ? (
                    <div className="arco_table1 table-responsive custom_scroll1">
                      <DataTable
                        columnData={eligibleTableColumn}
                        rowData={eligibleList}
                        onChangeTable={handleEligibleTableChange}
                        total={eligibleTotalPages}
                        current={eligibleCurrentPage}
                        loading={loading && activeTab === TAB_KEYS.ELIGIBLE}
                      />
                    </div>
                  ) : (
                    <NoData title={"No eligible Smart PBL chitties found"} />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PassbookOdList;
